import React from "react"
import { useSelector } from "react-redux"

import { QidDatapoint } from "server/models"
import { StoreType } from "client/store"
import {
    TableColumnEditable,
    Empty,
    // DateFormatter,
} from "client/components"

import TableSelect from "./components/select"
// import TableDatePicker from "./components/datepicker"
import TableInput from "./components/input"


const Columns = (isNested: boolean) => {
    const lang = useSelector((state: StoreType) => state.system.lang)

    const columns: TableColumnEditable[] = [
        {
            field: "status",
            header: lang.status,
            cellMinWidth: "150px",
        },
        {
            field: "reference",
            header: lang.reference,
            cellMinWidth: "200px",
            cellMaxWidth: "300px",
            editAccess: (datapoint: QidDatapoint) => !datapoint.failureMode,
            formatter: (datapoint: QidDatapoint) => {
                if (datapoint.datapointId) return null // don't display for nested rows
                if (!datapoint.reference) return <Empty />

                const { revision, file } = datapoint.reference
                const title = `${file.name} - rev. ${revision}`
                return (
                    <span title={title}>{title}</span>
                )
            },
            focusedFormatter: (datapoint: QidDatapoint) => (
                <TableSelect data={datapoint.reference} />
            ),
        },
        /* >>> temporarily disabled <<<
        {
            field: "publicationDate",
            header: lang.publicationDate,
            cellMinWidth: "150px",
            editAccess: (datapoint: QidDatapoint) => !datapoint.failureMode,
            formatter: (datapoint: QidDatapoint) => {
                if (datapoint.datapointId !== null) return null
                return <DateFormatter date={datapoint.publicationDate} showTime={false} />
            },
            focusedFormatter: (datapoint: QidDatapoint) => (
                <TableDatePicker data={datapoint.publicationDate} />
            ),
        },
        */
    ]

    if (isNested) {
        columns.push({
            field: "failureMode",
            header: lang.failureMode,
            cellMinWidth: "250px",
            formatter: (datapoint: QidDatapoint) => datapoint.failureMode && (
                <span title={datapoint.failureMode.name}>
                    {datapoint.failureMode.name}
                </span>
            ),
        })
    }

    columns.push(
        {
            field: "sd",
            header: lang.sd,
            cellMinWidth: "100px",
            editAccess: () => true,
            formatter: (datapoint: QidDatapoint) => datapoint.sd || <Empty />,
            focusedFormatter: (datapoint: QidDatapoint) => (
                <TableInput data={datapoint.sd} />
            ),
        },
        {
            field: "su",
            header: lang.su,
            cellMinWidth: "100px",
            editAccess: () => true,
            formatter: (datapoint: QidDatapoint) => datapoint.su || <Empty />,
            focusedFormatter: (datapoint: QidDatapoint) => (
                <TableInput data={datapoint.su} />
            ),
        },
        {
            field: "dd",
            header: lang.dd,
            cellMinWidth: "100px",
            editAccess: () => true,
            formatter: (datapoint: QidDatapoint) => datapoint.dd || <Empty />,
            focusedFormatter: (datapoint: QidDatapoint) => (
                <TableInput data={datapoint.dd} />
            ),
        },
        {
            field: "du",
            header: lang.du,
            cellMinWidth: "100px",
            editAccess: () => true,
            formatter: (datapoint: QidDatapoint) => datapoint.du || <Empty />,
            focusedFormatter: (datapoint: QidDatapoint) => (
                <TableInput data={datapoint.du} />
            ),
        },
        {
            field: "ne",
            header: lang.ne,
            cellMinWidth: "100px",
            editAccess: () => true,
            formatter: (datapoint: QidDatapoint) => datapoint.ne || <Empty />,
            focusedFormatter: (datapoint: QidDatapoint) => (
                <TableInput data={datapoint.ne} />
            ),
        },
        {
            field: "np",
            header: lang.np,
            cellMinWidth: "100px",
            editAccess: () => true,
            formatter: (datapoint: QidDatapoint) => datapoint.np || <Empty />,
            focusedFormatter: (datapoint: QidDatapoint) => (
                <TableInput data={datapoint.np} />
            ),
        },
        {
            field: "delete",
            cellMinWidth: "150px",
        },
    )

    return columns
}
export default Columns
